import { WorkOrder as VbsWorkOrder } from "@/services/backend/vbs/work-orders/types/work-order";
import { useEffect } from "react";
import { useVbsTreatmentShowQuery } from "@/services/backend/vbs/treatments/api/treatment-api";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { formatDate } from "@/shared/lib/utilities/date";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $createTextNode, $getRoot } from "lexical";
import { ConnectInvoiceExportDialog } from "@/services/backend/connect/components/connect-invoice-export";
import {
  useVbsPricing,
  useVbsSegmentPrices,
} from "@/services/backend/connect/components/string-builder-helpers-vbs";
import {
  useAttachmentsString,
  useServiceKindTitle,
  useWorkOrderReference,
} from "@/services/backend/connect/components/string-builder-helpers";

export function ConnectInvoiceExportDialogVbs({
  workOrder,
}: {
  workOrder: VbsWorkOrder;
}) {
  return (
    <ConnectInvoiceExportDialog>
      <VbsInvoiceExport workOrder={workOrder} />
    </ConnectInvoiceExportDialog>
  );
}

export function VbsInvoiceExport({ workOrder }: { workOrder: VbsWorkOrder }) {
  const [editor] = useLexicalComposerContext();
  const { data: treatment } = useVbsTreatmentShowQuery({
    id: workOrder.treatmentId,
  });

  const title = useServiceKindTitle(GSMServiceKind.VBS);
  const workOrderReference = useWorkOrderReference(
    workOrder.id,
    GSMServiceKind.VBS,
  );
  const segmentPrices = useVbsSegmentPrices(treatment);
  const pricing = useVbsPricing(workOrder.pricingId);
  const attachments = useAttachmentsString();

  useEffect(() => {
    editor.update(() => {
      const root = $getRoot();
      root.clear();

      const paragraphNode = $createParagraphNode();

      paragraphNode.append($createTextNode(title));
      paragraphNode.append($createTextNode("\n\n"));
      paragraphNode.append($createTextNode(workOrderReference));
      paragraphNode.append($createTextNode("\n"));
      paragraphNode.append(
        $createTextNode(
          `Leistungszeitpunkt: ${formatDate(workOrder.beginDate)}`,
        ),
      );
      paragraphNode.append($createTextNode("\n\n"));
      paragraphNode.append($createTextNode(segmentPrices));
      paragraphNode.append($createTextNode("\n"));
      paragraphNode.append($createTextNode(pricing));
      paragraphNode.append($createTextNode("\n\n"));
      paragraphNode.append($createTextNode(attachments));

      root.append(paragraphNode);
    });
  });

  return null;
}
